const type = 'SET_DATE'
const defaultDate = '2100-01-01T00:00:00.000Z'
const reducer = (state = defaultDate, action) => action.type === type ? action.date : state
const set = (date) => ({ type, date })
const reset = () => set(defaultDate)

export default { set: set, reset: reset, reducer: reducer }
